export { default } from './createChainedFunction';